module.exports = __webpack_public_path__ + "assets/images/boundaries/keys-six-members/key-pasir-ris/key-2.svg?v=987bb648";